// Customizer const
export const TOGGLE_COLLAPSED_NAV = "toggle_collapse_menu";
export const DRAWER_TYPE = "drawer_type";
export const FIXED_DRAWER = "fixed_drawer";
export const COLLAPSED_DRAWER = "collapsible";
export const MINI_DRAWER = "mini_drawer";
export const THEME_COLOR = "theme_color";
export const DARK_THEME = "dark_theme";
export const WINDOW_WIDTH = "window-width";
export const SWITCH_LANGUAGE = "switch-language";
export const CHANGE_DIRECTION = "change-direction";

export const CHANGE_NAVIGATION_STYLE = "change-navigation-style";
export const HORIZONTAL_NAVIGATION = "horizontal_navigation";
export const VERTICAL_NAVIGATION = "vertical_navigation";

export const HORIZONTAL_MENU_POSITION = "horizontal_menu_position";
export const ABOVE_THE_HEADER = "above_the_header";
export const INSIDE_THE_HEADER = "inside_the_header";
export const BELOW_THE_HEADER = "below_the_header";

// settings notification action types
export const SHOW_MESSAGE_ON = "SHOW_MESSAGE_ON";
export const SHOW_MESSAGE_OFF = "SHOW_MESSAGE_OFF";
export const ERROR_MESSAGE_ON = "ERROR_MESSAGE_ON";
export const ERROR_MESSAGE_OFF = "ERROR_MESSAGE_OFF";
export const SETTING_HANDLE_REQUEST_CLOSE = "SETTING_HANDLE_REQUEST_CLOSE";

// Contact Module const

export const SHOW_MESSAGE = "show_message";
export const HIDE_MESSAGE = "hide_message";

export const FETCH_ALL_CONTACT = "fetch_all_contact";
export const FETCH_ALL_CONTACT_SUCCESS = "fetch_all_contact_success";
export const ADD_FAVOURITE = "add_favourite";
export const ON_CONTACT_SELECT = "on_contact_select";
export const ON_ADD_CONTACT = "on_add_contact";
export const ON_ADD_CONTACT_STATE = "ON_ADD_CONTACT_STATE";
export const ON_CONTACT_CLOSE = "on_contact_close";
export const ON_FILTER_OPTION_SELECT = "on_filter_option_select";
export const ON_SAVE_CONTACT = "on_save_contact";
export const ON_SAVE_CONTACT_STATE = "ON_SAVE_CONTACT_STATE";
export const ON_DELETE_CONTACT = "on_delete_contact";
export const ON_DELETE_SELECTED_CONTACT = "on_delete_selected_contact";
export const FILTER_CONTACT = "filter_contact";
export const GET_ALL_CONTACT = "get_all_contact";
export const GET_UNSELECTED_ALL_CONTACT = "get_unselected_all_contact";
export const ON_ALL_CONTACT_SELECT = "on_all_contact_select";
export const UPDATE_SEARCH_USER = "update_search_user";
export const ON_TOGGLE_DRAWER = "on_toggle_drawer";
export const HANDLE_REQUEST_CLOSE = "handle_request_close";
export const HIDE_CONTACT_LOADER = "hide_contact_loader";

// Auth const
export const SIGNUP_USER = "signup_user";
export const SIGNUP_USER_SUCCESS = "signup_user_success";
export const SIGNIN_GOOGLE_USER = "signin_google_user";
export const SIGNIN_GOOGLE_USER_SUCCESS = "signin_google_user_success";
export const SIGNIN_FACEBOOK_USER = "signin_facebook_user";
export const SIGNIN_FACEBOOK_USER_SUCCESS = "signin_facebook_user_success";
export const SIGNIN_TWITTER_USER = "signin_twitter_user";
export const SIGNIN_TWITTER_USER_SUCCESS = "signin_twitter_user_success";
export const SIGNIN_GITHUB_USER = "signin_github_user";
export const SIGNIN_GITHUB_USER_SUCCESS = "signin_github_user_SUCCESS";
export const SIGNIN_USER = "signin_user";
export const SIGNIN_USER_SUCCESS = "signin_user_success";
export const SIGNOUT_USER = "signout_user";
export const SIGNOUT_USER_SUCCESS = "signout_user_success";
export const INIT_URL = "init_url";

// Chat Module const

export const FETCH_ALL_CHAT_USER = "fetch_all_chat_user";
export const FETCH_ALL_CHAT_USER_CONVERSATION = "fetch_all_chat_user_conversation";
export const FETCH_ALL_CHAT_USER_SUCCESS = "fetch_all_chat_user_success";
export const FETCH_ALL_CHAT_USER_CONVERSATION_SUCCESS = "fetch_all_chat_user_conversation_success";
export const FILTER_USERS = "filter_users";
export const ON_SELECT_USER = "on_select_user";
export const ON_SHOW_LOADER = "on_show_loader";
export const ON_HIDE_LOADER = "on_hide_loader";
export const USER_INFO_STATE = "user_info_state";
export const SUBMIT_COMMENT = "submit_comment";
export const UPDATE_MESSAGE_VALUE = "update_message_value";
export const UPDATE_SEARCH_CHAT_USER = "update_search_chat_user";

// // Mail Module const

export const ADD_LABEL = "ADD_LABEL";
export const GET_ALL_MAIL = "get_all_mail";
export const FETCH_ALL_MAIL = "fetch_all_mail";
export const FETCH_ALL_MAIL_SUCCESS = "fetch_all_mail_success";
export const GET_IMPORTANT_MAIL = "get_important_mail";
export const GET_NAV_FILTERS = "get_nav_filters";
export const GET_NAV_LABELS = "get_nav_labels";
export const GET_NAV_FOLDER = "get_nav_folder";
export const GET_READ_MAIL = "get_read_mail";
export const GET_STARRED_MAIL = "get_starred_mail";
export const GET_UNIMPORTANT_MAIL = "get_unimportant_mail";
export const GET_UNREAD_MAIL = "get_unread_mail";
export const GET_UNSELECTED_ALL_MAIL = "get_unselected_all_mail";
export const GET_UNSTARRED_MAIL = "get_unstarred_mail";
export const ON_ALL_MAIL_SELECT = "on_all_mail_select";
export const ON_FOLDER_MENU_ITEM_SELECT = "on_folder_menu_item_select";
export const ON_FOLDER_SELECT = "on_folder_select";
export const ON_IMPORTANT_SELECT = "on_important_select";
export const ON_LABEL_MENU_ITEM_SELECT = "on_label_menu_item_select";
export const GET_MARK_AS_START = "get_mark_as_start";
export const ON_LABEL_SELECT = "on_label_select";
export const ON_MAIL_CHECKED = "on_mail_checked";
export const ON_MAIL_SELECT = "on_mail_select";
export const ON_MAIL_SEND = "on_mail_send";
export const ON_OPTION_MENU_ITEM_SELECT = "on_option_menu_item_select";
export const ON_OPTION_MENU_SELECT = "on_option_menu_select";
export const ON_START_SELECT = "on_start_select";
export const SEARCH_MAIL = "search_mail";
export const ON_DELETE_MAIL = "on_delete_mail";
export const SET_CURRENT_MAIL_NULL = "set_current_mail_null";
export const ON_COMPOSE_MAIL = "on_compose_mail";

// // TO-DO Module const

export const ON_SORTEND = "on_sortend";
export const FETCH_ALL_TODO = "fetch_all_todo";
export const FETCH_ALL_TODO_SUCCESS = "fetch_all_todo-success";
export const FETCH_ALL_TODO_CONVERSATION = "fetch_all_todo_conversation";
export const FETCH_ALL_TODO_CONVERSATION_SUCCESS = "fetch_all_todo_conversation_success";
export const SELECT_ALL_TODO = "select_all_todo";
export const GET_ALL_TODO = "get_all_todo";
export const GET_UNSELECTED_ALL_TODO = "get_unselected_all_todo";
export const GET_STARRED_TODO = "get_starred_todo";
export const GET_UNSTARRED_TODO = "get_unstarred_todo";
export const GET_IMPORTANT_TODO = "get_important_todo";
export const GET_UNIMPORTANT_TODO = "get_unimportant_todo";
export const ON_LABEL_UPDATE = "on_label_update";
export const ON_TODO_UPDATE = "on_todo_update";
export const ON_DELETE_TODO = "on_delete_todo";
export const SEARCH_TODO = "search_todo";
export const SHOW_TODOS = "show_todos";
export const GET_TODO_CONVERSATION = "get_todo_conversation";
export const ON_TODO_CHECKED = "on_todo_checked";
export const ON_TODO_ADD = "on_todo_add";
export const ON_TODO_SELECT = "on_todo_select";
export const SET_CURRENT_TODO_NULL = "set_current_todo_null";
export const REMOVE_LABEL = "remove_label";
export const UPDATE_SEARCH = "update_search";

//

// Business Page actions types

export const GET_BUSINESS_PAGE = "get_business_page";
export const SET_BUSINESS_PAGE = "set_business_page";
export const CHANGE_MODAL_NAME = "CHANGE_MODAL_NAME";
export const CHANGE_MODAL_EMAIL = "CHANGE_MODAL_EMAIL";
export const CHANGE_MODAL_MESSAGE = "CHANGE_MODAL_MESSAGE";
export const SEND_MODAL_FORM = "SEND_MODAL_FORM";
export const SEND_MODAL_FORM_RESPONSE = "SEND_MODAL_FORM_RESPONSE";
export const BUSINESS_PAGE_RESET = "BUSINESS_PAGE_RESET";

// Change Title of Page action Types

export const CHANGE_TITLE = "change_title";

// Book-Appointment actions types

export const GET_ALL_SERVICES = "get_all_services";
export const SET_ALL_SERVICES = "set_all_services";
export const SET_EMPLOYEE_SELECTED = "SET_EMPLOYEE_SELECTED";
export const SET_FROM = "SET_FROM";
export const GET_ALL_IDS = "get_all_ids";
export const BOOK_APPOINTMENT_RESET = "BOOK_APPOINTMENT_RESET";

// Customer Booking Page actions types

export const GET_CUSTOMER_BOOKING_PAGE = "get_customer_booking_page";
export const SET_CUSTOMER_BOOKING_PAGE = "set_customer_booking_page";
export const SET_BUSINESS_TYPE_ID = "SET_BUSINESS_TYPE_ID";

// Time SLots for the weeks in modal action types

export const GET_TIME_SLOTS = "get_time_slots";
export const SET_TIME_SLOTS = "set_time_slots";

// Business Details
export const SET_BUSINESS_DETAIL = "set_business_detail";
export const SET_BUSINESS_ID = "set_business_id";
export const SET_BUSINESS_LOCATION_ID = "set_business_location_id";

// Modal Page action types

export const SET_SELECTED_DATE = "SET_SELECTED_DATE";
export const SET_EMPLOYEE_SELECTED_ID = "SET_EMPLOYEE_SELECTED_ID";
export const SET_APPOINTMENT_EMPLOYEE_DETAILS = "SET_APPOINTMENT_EMPLOYEE_DETAILS";
export const SET_MODAL_ID = "SET_MODAL_ID";
export const SET_EMPLOYEES_AND_SERVICE = "SET_EMPLOYEES_AND_SERVICE";
export const SAVE_FORM_DATA = "save_form_data";
export const SET_CONTINUE_BOOKING_DATA = 'SET_CONTINUE_BOOKING_DATA';
export const RESET_CONTINUE_BOOKING_DATA = 'RESET_CONTINUE_BOOKING_DATA';

// timing selection actions types

export const SET_TIMING_SELECTED = "SET_TIMING_SELECTED";

export const BOOK_CUSTOMER_APPOINTMENT = "book_customer_appointment";
export const SET_CONFIRMATION_PAGE = "set_confirmation_page";
export const GET_FORM_DATA = "get_form_data";

// login page actions type

export const LOGIN_PAGE_SIGNIN = "LOGIN_PAGE_SIGNIN";
export const LOGIN_PAGE_SIGNUP = "LOGIN_PAGE_SIGNUP";
export const LOGIN_PAGE_EMAIL = "LOGIN_PAGE_EMAIL";
export const LOGIN_PAGE_FIRST_NAME = "LOGIN_PAGE_FIRST_NAME";
export const LOGIN_PAGE_PHONE_NUMBER = "LOGIN_PAGE_PHONE_NUMBER";
export const LOGIN_PAGE_PASSWORD = "LOGIN_PAGE_PASSWORD";
export const LOGIN_PAGE_VERIFY = "LOGIN_PAGE_VERIFY";
export const LOGIN_PAGE_CHANGE_VERIFY = "LOGIN_PAGE_CHANGE_VERIFY";
export const LOGIN_SHOW_LOADER = "LOGIN_SHOW_LOADER";
export const LOGIN_SHOW_MESSAGE = "LOGIN_SHOW_MESSAGE";
export const LOGIN_HIDE_MESSAGE = "LOGIN_HIDE_MESSAGE";
export const LOGIN_HIDE_LOADER = "LOGIN_HIDE_LOADER";
export const LOGIN_PAGE_FORGOT_PASSWORD = "LOGIN_PAGE_FORGOT_PASSWORD";
export const LOGIN_PAGE_FORGOT_PASSWORD_SUCCESS = "LOGIN_PAGE_FORGOT_PASSWORD_SUCCESS";
export const LOGIN_PAGE_CONFIRM_PASSWORD = "LOGIN_PAGE_CONFIRM_PASSWORD";
export const LOGIN_PAGE_RESET_PASSWORD = "LOGIN_PAGE_RESET_PASSWORD";
export const USER_ACTIVATION = "USER_ACTIVATION";
export const AUTH_SUCCESS = "AUTH_SUCCESS";

// logout actions type

export const LOGOUT_USER = "LOGOUT_USER";
export const LOGOUT_USER_RESPONSE = "LOGOUT_USER_RESPONSE";

// admin book appointment page action types

export const SET_DATE = "set_date";
export const SET_VIEW = "set_view";
export const NEXT_BUTTON = "next_button";
export const GET_CALENDAR = "get_calendar";
export const SET_CALENDAR_DATA = "set_calendar_data";
export const TOGGLE_MODAL = "toggle_modal";
export const SET_SELECTED_EMPLOYEE = "set_selected_employee";
export const SET_SELECTED_SERVICE = "set_selected_service";
export const SET_APPOINTMENT_DATE = "set_appointment_date";
export const SET_APPOINTMENT_TIME = "set_appointment_time";
export const ADMIN_BOOK_APPOINTMENT = "admin_book_appointment";
export const ADMIN_BOOK_APPOINTMENT_RESPONSE = "admin_book_appointment_RESPONSE";
export const ADMIN_BOOKING_SHOW_MESSAGE = "admin_booking_show_message";
export const ADMIN_BOOKING_HIDE_MESSAGE = "admin_booking_hide_message";
export const SET_ADMIN_EMPLOYEE_SELECTED = "SET_ADMIN_EMPLOYEE_SELECTED";
export const SET_ADMIN_ALL_EMPLOYEE_SELECTED = "SET_ADMIN_ALL_EMPLOYEE_SELECTED";
export const CHANGE_ADMIN_LOADER = "CHANGE_ADMIN_LOADER";
export const SET_CUSTOMER_LIST = "set_customer_list";
export const SET_SELECTED_CUSTOMER = "set_selected_customer";
export const SET_MODAL_INITIATOR = "set_modal_initiator";
export const SET_APPOINTMENT_STATUS = "set_appointment_status";
export const SET_APPOINTMENT_MESSAGE = "set_appointment_message";
export const EDIT_ADMIN_APPOINTMENT = "edit_admin_appointment";
export const EDIT_ADMIN_APPOINTMENT_RESPONSE = "edit_admin_appointment_RESPONSE";
export const SET_APPOINTMENT_ID = "set_appointment_id";
export const SET_CALENDAR_VIEW = "set_calendar_view";
export const SET_SINGLE_SELECTED_EMPLOYEE = "set_single_selected_employee";
export const OPEN_EMPLOYEE_SELECTION = "open_employee_selectionmodal";
export const SET_MONTHLY_SELECT_EMPLOYEE = "set_monthly_select_employee";
export const REMOVE_WORKING_HOURS_EMPLOYEE = "REMOVE_WORKING_HOURS_EMPLOYEE";
export const TOGGLE_CUSTOMER_MODAL = "TOGGLE_CUSTOMER_MODAL";
export const CHANGE_CUSTOMER_ADD_STATE = "CHANGE_CUSTOMER_ADD_STATE";
export const CALL_CUSTOMERS_API = "CALL_CUSTOMERS_API";
export const CALL_CUSTOMERS_API_RESPONSE = "CALL_CUSTOMERS_API_RESPONSE";
export const ADMIN_BOOK_FAIL_RESPONSE = "ADMIN_BOOK_FAIL_RESPONSE";
export const ADMIN_BOOK_REQUEST_CLOSE = "ADMIN_BOOK_REQUEST_CLOSE";
export const UPDATE_CUSTOMER_LIST = "UPDATE_CUSTOMER_LIST";
export const ADMIN_BOOK_LOADER_SHOW = "admin_book_loader_show";
export const ADMIN_BOOK_LOADER_HIDE = "admnin_book_loader_hide";
export const ADMIN_BOOK_MAIN_LOADER_SHOW = "ADMIN_BOOK_MAIN_LOADER_SHOW";
export const ADMIN_BOOK_MAIN_LOADER_HIDE = "ADMIN_BOOK_MAIN_LOADER_HIDE";

// working hours actions types
export const GET_EMPLOYEE_WORKING_HOURS = "GET_EMPLOYEE_WORKING_HOURS";
export const SET_EMPLOYEE_WORKING_HOURS = "SET_EMPLOYEE_WORKING_HOURS";
export const SET_EMPLOYEE_WORKING_HOURS_DATE = "SET_EMPLOYEE_WORKING_HOURS_DATE";
export const SET_EMPLOYEE_WORKING_HOURS_FROM = "SET_EMPLOYEE_WORKING_HOURS_FROM";
export const SET_EMPLOYEE_WORKING_HOURS_TO = "SET_EMPLOYEE_WORKING_HOURS_TO";
export const SET_EMPLOYEE_WORKING_HOURS_COMMENT = "SET_EMPLOYEE_WORKING_HOURS_COMMENT";
export const SUBMIT_WORKING_HOURS_FORM = "SUBMIT_WORKING_HOURS_FORM";
export const CHANGE_WORKING_HOURS_SUBMIT = "CHANGE_WORKING_HOURS_SUBMIT";
export const WORKING_HOURS_UPDATE = "WORKING_HOURS_UPDATE";

// admin employee page action types
export const CHANGE_ADMIN_EMPLOYEE_DISPLAY = "CHANGE_ADMIN_EMPLOYEE_DISPLAY";
export const GET_ALL_SERVICES_BY_BUSINESS = "GET_ALL_SERVICES_BY_BUSINESS";
export const SET_ALL_SERVICES_BY_BUSINESS = "SET_ALL_SERVICES_BY_BUSINESS";
export const SET_IMAGE_FILE = "SET_IMAGE_FILE";
export const GET_IMAGE_FILE = "GET_IMAGE_FILE";
export const SET_SERVICE_TABLE_SERVICES = "SET_SERVICE_TABLE_SERVICES";
export const GET_SERVICE_TABLE_SERVICES = "GET__SERVICE_TABLE_SERVICES";
export const SUBMIT_ALL_VALUES_EMPLOYEE = "SUBMIT_ALL_VALUES_EMPLOYEE";
export const SUBMIT_ALL_VALUES_EMPLOYEE_RESPONSE = "SUBMIT_ALL_VALUES_EMPLOYEE_RESPONSE";
export const FILL_ADMIN_EMPLOYEE_SELECTED_DETAILS = "FILL_ADMIN_EMPLOYEE_SELECTED_DETAILS";
export const REMOVE_EMPLOYEE_IMAGE = "REMOVE_EMPLOYEE_IMAGE";
export const SUBMIT_EDIT_EMPLOYEE_DETAILS = "SUBMIT_EDIT_EMPLOYEE_DETAILS";
export const SUBMIT_EDIT_EMPLOYEE_DETAILS_RESPONSE = "SUBMIT_EDIT_EMPLOYEE_DETAILS_RESPONSE";
export const CHANGE_ADD_EMPLOYEE_STATE = "CHANGE_ADD_EMPLOYEE_STATE";
export const CHANGE_EDIT_EMPLOYEE_STATE = "CHANGE_EDIT_EMPLOYEE_STATE";
export const CLEAR_FORM_DATA = "CLEAR_FORM_DATA";
export const SELECTED_EMPLOYEE_DELETE = "SELECTED_EMPLOYEE_DELETE";
export const SELECTED_EMPLOYEE_DELETE_RESPONSE = "SELECTED_EMPLOYEE_DELETE_RESPONSE";
export const EMPLOYEE_FAIL_RESPONSE = "EMPLOYEE_FAIL_RESPONSE";
export const EMPLOYEE_ON_HIDE_LOADER = "EMPLOYEE_ON_HIDE_LOADER";
export const EMPLOYEE_ON_SHOW_LOADER = "EMPLOYEE_ON_SHOW_LOADER";
export const BUSINESS_EXCEPTION_BASED_AVAILIABLITY = "BUSINESS_EXCEPTION_BASED_AVAILIABLITY";
export const GET_EMPLOYEE_PLAN = "GET_EMPLOYEE_PLAN";
export const GET_EMPLOYEE_PLAN_SUCCESS = "GET_EMPLOYEE_PLAN_SUCCESS";

// employee working hours action types
export const EMPLOYEE_DELETE_WORKING_HOURS_MODAL_TOGGLE =
  "EMPLOYEE_DELETE_WORKING_HOURS_MODAL_TOGGLE";
export const EMPLOYEE_DONT_DELETE_WORKING_HOURS = "EMPLOYEE_DONT_DELETE_WORKING_HOURS";
export const EMPLOYEE_DELETE_WORKING_HOURS_FORCEFULLY = "EMPLOYEE_DELETE_WORKING_HOURS_FORCEFULLY";
export const EMPLOYEE_DELETE_WORKING_HOURS_FORCEFULLY_RESPONSE =
  "EMPLOYEE_DELETE_WORKING_HOURS_FORCEFULLY_RESPONSE";
export const EMPLOYEE_OUT_OF_BUSINESS_HOURS_ADD = "EMPLOYEE_OUT_OF_BUSINESS_HOURS_ADD";
export const EMPLOYEE_ADD_WORKING_HOURS_FORCEFULLY = "EMPLOYEE_ADD_WORKING_HOURS_FORCEFULLY";
export const EMPLOYEE_ADD_WORKING_HOURS_FORCEFULLY_RESPONSE =
  "EMPLOYEE_ADD_WORKING_HOURS_FORCEFULLY_RESPONSE";
export const EMPLOYEE_EDIT_WORKING_HOURS_FORCEFULLY_RESPONSE =
  "EMPLOYEE_EDIT_WORKING_HOURS_FORCEFULLY_RESPONSE";
export const BULK_EMPLOYEE_CLOSE_WORKING_HOURS = "BULK_EMPLOYEE_CLOSE_WORKING_HOURS";
export const BULK_EMPLOYEE_ADD_WORKING_HOURS_FORCEFULLY =
  "BULK_EMPLOYEE_ADD_WORKING_HOURS_FORCEFULLY";
export const BULK_EMPLOYEE_ADD_WORKING_HOURS_FORCEFULLY_RESPONSE =
  "BULK_EMPLOYEE_ADD_WORKING_HOURS_FORCEFULLY_RESPONSE";
export const BULK_EMPLOYEE_CALENDER_RESPONSE = "BULK_EMPLOYEE_CALENDER_RESPONSE";
export const EMPLOYEE_WORKING_HOURS_SHOW_LOADER = "EMPLOYEE_WORKING_HOURS_SHOW_LOADER";
export const EMPLOYEE_WORKING_HOURS_HIDE_LOADER = "EMPLOYEE_WORKING_HOURS_HIDE_LOADER";
export const EMPLOYEE_WORKING_HOURS_CLEAR_TABLE = "EMPLOYEE_WORKING_HOURS_CLEAR_TABLE";
export const EMPLOYEE_WORKING_HOURS_NEW_REQUEST_CLOSE = "EMPLOYEE_WORKING_HOURS_NEW_REQUEST_CLOSE";
export const EMPLOYEE_BUSINESS_CLOSURE_FROM = "EMPLOYEE_BUSINESS_CLOSURE_FROM";
export const EMPLOYEE_BUSINESS_CLOSURE_TO = "EMPLOYEE_BUSINESS_CLOSURE_TO";
export const EMPLOYEE_BUSINESS_CLOSURE_DAY = "EMPLOYEE_BUSINESS_CLOSURE_DAY";
export const EMPLOYEE_BUSINESS_CLOSURE_DAY_ERROR_ADD = "EMPLOYEE_BUSINESS_CLOSURE_DAY_ERROR_ADD";
export const EMPLOYEE_BUSINESS_CLOSURE_DAY_ERROR_REMOVE =
  "EMPLOYEE_BUSINESS_CLOSURE_DAY_ERROR_REMOVE";
export const EMPLOYEE_BUSINESS_CLOSURE_SUBMIT = "EMPLOYEE_BUSINESS_CLOSURE_SUBMIT";
export const EMPLOYEE_BUSINESS_CLOSURE_SUBMIT_RESPONSE =
  "EMPLOYEE_BUSINESS_CLOSURE_SUBMIT_RESPONSE";
export const EMPLOYEE_BUSINESS_CLOSURE_CANCEL = "EMPLOYEE_BUSINESS_CLOSURE_CANCEL";
export const EMPLOYEE_BUSINESS_CLOSURE_OPERATIONS_SET = "EMPLOYEE_BUSINESS_CLOSURE_OPERATIONS_SET";
export const EMPLOYEE_BUSINESS_CLOSURE_SCHEDULE_SET = "EMPLOYEE_BUSINESS_CLOSURE_SCHEDULE_SET";
export const EMPLOYEE_BUSINESS_WORKING_HOURS_SUBMIT = "EMPLOYEE_BUSINESS_WORKING_HOURS_SUBMIT";
export const EMPLOYEE_BUSINESS_WORKING_HOURS_DELETE_SUBMIT =
  "EMPLOYEE_BUSINESS_WORKING_HOURS_DELETE_SUBMIT";
export const EMPLOYEE_BUSINESS_WORKING_HOURS_SUBMIT_RESPONSE =
  "EMPLOYEE_BUSINESS_WORKING_HOURS_SUBMIT_RESPONSE";
export const EMPLOYEE_BUSINESS_WORKING_HOURS_EDIT_SUBMIT_RESPONSE =
  "EMPLOYEE_BUSINESS_WORKING_HOURS_EDIT_SUBMIT_RESPONSE";
export const EMPLOYEE_BUSINESS_WORKING_HOURS_DELETE_SUBMIT_RESPONSE =
  "EMPLOYEE_BUSINESS_WORKING_HOURS_DELETE_SUBMIT_RESPONSE";
export const EMPLOYEE_BUSINESS_WORKING_HOURS_ADD_FORCEFULLY =
  "EMPLOYEE_BUSINESS_WORKING_HOURS_ADD_FORCEFULLY";
export const EMPLOYEE_BUSINESS_WORKING_HOURS_ADD_FORCEFULLY2 =
  "EMPLOYEE_BUSINESS_WORKING_HOURS_ADD_FORCEFULLY2";
export const EMPLOYEE_BUSINESS_WORKING_HOURS_ADD_FORCEFULLY_RESPONSE =
  "EMPLOYEE_BUSINESS_WORKING_HOURS_ADD_FORCEFULLY_RESPONSE";
export const EMPLOYEE_BUSINESS_WORKING_HOURS_EDIT_FORCEFULLY =
  "EMPLOYEE_BUSINESS_WORKING_HOURS_EDIT_FORCEFULLY";
export const EMPLOYEE_BUSINESS_WORKING_HOURS_EDIT_FORCEFULLY_RESPONSE =
  "EMPLOYEE_BUSINESS_WORKING_HOURS_EDIT_FORCEFULLY_RESPONSE";
export const EMPLOYEE_BUSINESS_WORKING_HOURS_DELETE_FORCEFULLY =
  "EMPLOYEE_BUSINESS_WORKING_HOURS_DELETE_FORCEFULLY";
export const EMPLOYEE_BUSINESS_WORKING_HOURS_DELETE_FORCEFULLY_RESPONSE =
  "EMPLOYEE_BUSINESS_WORKING_HOURS_DELETE_FORCEFULLY_RESPONSE";
export const EMPLOYEE_BUSINESS_WORKING_HOURS_HAVE_APPOINTMENT =
  "EMPLOYEE_BUSINESS_WORKING_HOURS_HAVE_APPOINTMENT";
export const EMPLOYEE_BUSINESS_WORKING_HOURS_DELETE_APPOINTMENT =
  "EMPLOYEE_BUSINESS_WORKING_HOURS_DELETE_APPOINTMENT";
export const EMPLOYEE_BUSINESS_HANDLE_REQUEST_CLOSE = "EMPLOYEE_BUSINESS_HANDLE_REQUEST_CLOSE";

// Customer Admin Module const

export const CUSTOMER_ADMIN_SHOW_MESSAGE = "CUSTOMER_ADMIN_show_message";
export const CUSTOMER_ADMIN_HIDE_MESSAGE = "CUSTOMER_ADMIN_hide_message";

export const CUSTOMER_ADMIN_FETCH_ALL_CONTACT = "CUSTOMER_ADMIN_fetch_all_contact";
export const CUSTOMER_ADMIN_FETCH_ALL_CONTACT_SUCCESS = "CUSTOMER_ADMIN_fetch_all_contact_success";

export const CUSTOMER_ADMIN_ADD_FAVOURITE = "CUSTOMER_ADMIN_add_favourite";
export const CUSTOMER_ADMIN_ON_CONTACT_SELECT = "CUSTOMER_ADMIN_on_contact_select";
export const CUSTOMER_ADMIN_ON_ADD_CONTACT = "CUSTOMER_ADMIN_on_add_contact";
export const CUSTOMER_ADMIN_ON_ADD_CONTACT_STATE = "CUSTOMER_ADMIN_ON_ADD_CONTACT_STATE";

export const CUSTOMER_ADMIN_ON_CONTACT_CLOSE = "CUSTOMER_ADMIN_on_contact_close";
export const CUSTOMER_ADMIN_ON_FILTER_OPTION_SELECT = "CUSTOMER_ADMIN_on_filter_option_select";

export const CUSTOMER_ADMIN_ON_SAVE_CONTACT = "CUSTOMER_ADMIN_on_save_contact";
export const CUSTOMER_ADMIN_ON_SAVE_CONTACT_STATE = "CUSTOMER_ADMIN_ON_SAVE_CONTACT_STATE";
export const CUSTOMER_ADMIN_ON_DELETE_CONTACT = "CUSTOMER_ADMIN_on_delete_contact";

export const CUSTOMER_ADMIN_ON_DELETE_SELECTED_CONTACT =
  "CUSTOMER_ADMIN_on_delete_selected_contact";
export const CUSTOMER_ADMIN_FILTER_CONTACT = "CUSTOMER_ADMIN_filter_contact";
export const CUSTOMER_ADMIN_GET_ALL_CONTACT = "CUSTOMER_ADMIN_get_all_contact";
export const CUSTOMER_ADMIN_GET_UNSELECTED_ALL_CONTACT =
  "CUSTOMER_ADMIN_get_unselected_all_contact";

export const CUSTOMER_ADMIN_ON_ALL_CONTACT_SELECT = "CUSTOMER_ADMIN_on_all_contact_select";
export const CUSTOMER_ADMIN_UPDATE_SEARCH_USER = "CUSTOMER_ADMIN_update_search_user";
export const CUSTOMER_ADMIN_ON_TOGGLE_DRAWER = "CUSTOMER_ADMIN_on_toggle_drawer";
export const CUSTOMER_ADMIN_HANDLE_REQUEST_CLOSE = "CUSTOMER_ADMIN_handle_request_close";

export const CUSTOMER_ADMIN_HIDE_CONTACT_LOADER = "CUSTOMER_ADMIN_hide_contact_loader";
export const SET_CUSTOMER_IMAGE_FILE = "SET_CUSTOMER_IMAGE_FILE";
export const REMOVE_CUSTOMER_IMAGE_FILE_PROFILE = "REMOVE_CUSTOMER_IMAGE_FILE_PROFILE";
export const GET_CUSTOMER_IMAGE_FILE = "GET_CUSTOMER_IMAGE_FILE";
export const CHANGE_CUSTOMER_ADMIN_DISPLAY = "CHANGE_CUSTOMER_ADMIN_DISPLAY";

export const SUBMIT_NEW_CUSTOMER_ADMIN = "SUBMIT_NEW_CUSTOMER_ADMIN";
export const SUBMIT_NEW_CUSTOMER_ADMIN_RESPONSE = "SUBMIT_NEW_CUSTOMER_ADMIN_RESPONSE";

export const HANDLE_DATE_OF_BIRTH = "HANDLE_DATE_OF_BIRTH";

export const FILL_ADMIN_CUSTOMER_SELECTED_DETAILS = "FILL_ADMIN_CUSTOMER_SELECTED_DETAILS";
export const SUBMIT_EDIT_CUSTOMER_DETAILS = "SUBMIT_EDIT_CUSTOMER_DETAILS";
export const SUBMIT_EDIT_CUSTOMER_DETAILS_RESPONSE = "SUBMIT_EDIT_CUSTOMER_DETAILS_RESPONSE";
export const CHANGE_ADD_CUSTOMER_STATE = "CHANGE_ADD_CUSTOMER_STATE";
export const CHANGE_EDIT_CUSTOMER_STATE = "CHANGE_EDIT_CUSTOMER_STATE";
export const CUSTOMER_CLEAR_FORM_DATA = "CUSTOMER_CLEAR_FORM_DATA";
export const SELECTED_CUSTOMER_DELETE = "SELECTED_CUSTOMER_DELETE";
export const SELECTED_CUSTOMER_DELETE_RESPONSE = "SELECTED_CUSTOMER_DELETE_RESPONSE";
export const CUSTOMER_FAIL_RESPONSE = "CUSTOMER_FAIL_RESPONSE";
export const CUSTOMER_ON_HIDE_LOADER2 = "CUSTOMER_ON_HIDE_LOADER2";
export const CUSTOMER_ON_SHOW_LOADER = "CUSTOMER_ON_SHOW_LOADER";
export const CHANGE_CUSTOMER_PROFILE_SET = "CHANGE_CUSTOMER_PROFILE_SET";

// SERVICES Admin Module const

export const SERVICES_ADMIN_SHOW_MESSAGE = "SERVICES_ADMIN_show_message";
export const SERVICES_ADMIN_HIDE_MESSAGE = "SERVICES_ADMIN_hide_message";

export const SERVICES_ADMIN_FETCH_ALL_CONTACT = "SERVICES_ADMIN_fetch_all_contact";
export const SERVICES_ADMIN_FETCH_ALL_CONTACT_SUCCESS = "SERVICES_ADMIN_fetch_all_contact_success";
export const SERVICES_ADMIN_ADD_FAVOURITE = "SERVICES_ADMIN_add_favourite";
export const SERVICES_ADMIN_ON_CONTACT_SELECT = "SERVICES_ADMIN_on_contact_select";
export const SERVICES_ADMIN_ON_ADD_CONTACT = "SERVICES_ADMIN_on_add_contact";
export const SERVICES_ADMIN_ON_ADD_CONTACT_STATE = "SERVICES_ADMIN_ON_ADD_CONTACT_STATE";
export const SERVICES_ADMIN_ON_CONTACT_CLOSE = "SERVICES_ADMIN_on_contact_close";
export const SERVICES_ADMIN_ON_FILTER_OPTION_SELECT = "SERVICES_ADMIN_on_filter_option_select";
export const SERVICES_ADMIN_ON_SAVE_CONTACT = "SERVICES_ADMIN_on_save_contact";
export const SERVICES_ADMIN_ON_SAVE_CONTACT_STATE = "SERVICES_ADMIN_ON_SAVE_CONTACT_STATE";
export const SERVICES_ADMIN_ON_DELETE_CONTACT = "SERVICES_ADMIN_on_delete_contact";
export const SERVICES_ADMIN_ON_DELETE_SELECTED_CONTACT =
  "SERVICES_ADMIN_on_delete_selected_contact";
export const SERVICES_ADMIN_FILTER_CONTACT = "SERVICES_ADMIN_filter_contact";
export const SERVICES_ADMIN_GET_ALL_CONTACT = "SERVICES_ADMIN_get_all_contact";
export const SERVICES_ADMIN_GET_UNSELECTED_ALL_CONTACT =
  "SERVICES_ADMIN_get_unselected_all_contact";
export const SERVICES_ADMIN_ON_ALL_CONTACT_SELECT = "SERVICES_ADMIN_on_all_contact_select";
export const SERVICES_ADMIN_UPDATE_SEARCH_USER = "SERVICES_ADMIN_update_search_user";
export const SERVICES_CATEGORY_ADMIN_UPDATE_SEARCH_USER = "SERVICES_CATEGORY_ADMIN_UPDATE_SEARCH_USER";
export const SERVICES_ADMIN_ON_TOGGLE_DRAWER = "SERVICES_ADMIN_on_toggle_drawer";
export const SERVICES_ADMIN_HANDLE_REQUEST_CLOSE = "SERVICES_ADMIN_handle_request_close";
export const SERVICES_ADMIN_HIDE_CONTACT_LOADER = "SERVICES_ADMIN_hide_contact_loader";
export const SERVICES_DELETE_MODAL_TOGGLE = "SERVICES_DELETE_MODAL_TOGGLE";

export const SUBMIT_NEW_SERVICES_ADMIN = "SUBMIT_NEW_SERVICES_ADMIN";
export const SUBMIT_NEW_SERVICES_ADMIN_RESPONSE = "SUBMIT_NEW_SERVICES_ADMIN_RESPONSE";

export const CHANGE_SERVICES_ADMIN_DISPLAY = "CHANGE_SERVICES_ADMIN_DISPLAY";
export const FILL_ADMIN_SERVICES_SELECTED_DETAILS = "FILL_ADMIN_SERVICES_SELECTED_DETAILS";
export const SUBMIT_EDIT_SERVICES_DETAILS = "SUBMIT_EDIT_SERVICES_DETAILS";
export const SUBMIT_EDIT_SERVICES_DETAILS_RESPONSE = "SUBMIT_EDIT_SERVICES_DETAILS_RESPONSE";
export const CHANGE_ADD_SERVICES_STATE = "CHANGE_ADD_SERVICES_STATE";
export const CHANGE_EDIT_SERVICES_STATE = "CHANGE_EDIT_SERVICES_STATE";
export const SERVICES_CLEAR_FORM_DATA = "CLEAR_FORM_DATA";
export const SELECTED_SERVICES_DELETE = "SELECTED_SERVICES_DELETE";
export const SELECTED_SERVICES_DELETE_RESPONSE = "SELECTED_SERVICES_DELETE_RESPONSE";
export const GET_SERVICES_CATEGORY = "GET_SERVICES_CATEGORY";
export const SET_SERVICES_CATEGORY = "SET_SERVICES_CATEGORY";
export const SET_SERVICES_BUSINESS_CATEGORY = "SET_SERVICES_BUSINESS_CATEGORY";
export const SELECT_CATEGORY_ID = "SELECT_CATEGORY_ID";
export const SELECT_SERVICES_ID = "SELECT_SERVICES_ID";
export const EDIT_SERVICE = "EDIT_SERVICE";
export const DELETE_SERVICE = "DELETE_SERVICE";
export const EDIT_SERVICE_REPONSE = "EDIT_SERVICE_REPONSE";
export const DELETED_SERVICE_RESPONSE = "DELETED_SERVICE_RESPOSNE";
export const HAVE_APPOINTMENT_DELETE_SERVICES = "HAVE_APPOINTMENT_DELETE_SERVICES";
export const APPOINTMENT_DELETE_SERVICES_FORCEFULLY = "APPOINTMENT_DELETE_SERVICES_FORCEFULLY";
export const APPOINTMENT_DELETE_SERVICES_FORCEFULLY_RESPONSE =
  "APPOINTMENT_DELETE_SERVICES_FORCEFULLY_RESPONSE";

export const SERVICES_FAIL_RESPONSE = "SERVICES_FAIL_RESPONSE";
export const SERVICES_ON_HIDE_LOADER2 = "SERVICES_ON_HIDE_LOADER2";
export const SERVICES_ON_SHOW_LOADER = "SERVICES_ON_SHOW_LOADER";

// admin working-hours action types
export const SET_WORKING_HOURS = "SET_WORKING_HOURS";
export const GET_WORKING_HOURS = "GET_WORKING_HOURS";
export const CHANGE_ADD_WORKING_HOURS_STATE = "CHANGE_ADD_WORKING_HOURS_STATE";
export const CHANGE_EDIT_WORKING_HOURS_STATE = "CHANGE_EDIT_WORKING_HOURS_STATE";
export const DELETE_SELECTED_WORKING_HOURS = "DELETE_SELECTED_WORKING_HOURS";
export const DELETE_SELECTED_WORKING_HOURS_RESPONSE = "DELETE_SELECTED_WORKING_HOURS_RESPONSE";
export const EDIT_WORKING_HOURS_RESPONSE = "EDIT_WORKING_HOURS_RESPONSE";
export const WORKING_HOURS_FAIL = "WORKING_HOURS_FAIL";
export const WORKING_HOURS_ON_HIDE_LOADER = "WORKING_HOURS_ON_HIDE_LOADER";
export const WORKING_HOURS_ON_SHOW_LOADER = "WORKING_HOURS_ON_SHOW_LOADER";
export const WORKING_HOURS_TOGGLE_MODAL = "WORKING_HOURS_TOGGLE_MODAL";
export const WORKING_HOURS_NEW_REQUEST_CLOSE = "WORKING_HOURS_NEW_REQUEST_CLOSE";

// admin closures action types
export const SET_CLOSURES = "SET_CLOSURES";
export const SUBMIT_CLOSURES_FORM = "SUBMIT_CLOSURES_FORM";
export const CLOSURES_UPDATE = "CLOSURES_UPDATE";
export const UPDATE_WORKING_HOURS = "UPDATE_WORKING_HOURS";
export const UPDATE_WORKING_HOURS_RESPONSE = "UPDATE_WORKING_HOURS_RESPONSE";
export const ADMIN_SETTINGS_DAY_FROM_UPDATE = "ADMIN_SETTINGS_DAY_FROM_UPDATE";
export const ADMIN_SETTINGS_DAY_FROM_UPDATE_RESPONSE = "ADMIN_SETTINGS_DAY_FROM_UPDATE_RESPONSE";
export const ADMIN_SETTINGS_DAY_TO_UPDATE = "ADMIN_SETTINGS_DAY_TO_UPDATE";
export const ADMIN_SETTINGS_DAY_TO_UPDATE_RESPONSE = "ADMIN_SETTINGS_DAY_TO_UPDATE_RESPONSE";
export const ADMIN_SETTINGS_SCHEDULE_SUBMIT = "ADMIN_SETTINGS_SCHEDULE_SUBMIT";
export const ADMIN_SETTINGS_SCHEDULE_SUBMIT_RESPONSE = "ADMIN_SETTINGS_SCHEDULE_SUBMIT_RESPONSE";
export const ADMIN_SETTINGS_CHANGE_ADD_STATE = "ADMIN_SETTINGS_CHANGE_ADD_STATE";
export const ADMIN_SETTINGS_CHANGE_EDIT_STATE = "ADMIN_SETTINGS_CHANGE_EDIT_STATE";
export const EDIT_CLOSURE = "EDIT_CLOSURE";
export const EDIT_CLOSURE_RESPONSE = "EDIT_CLOSURE_RESPONSE";
export const FAIL_RESPONSE_MESSAGE = "FAIL_RESPONSE_MESSAGE";
export const DELETE_CLOSURES = "DELETE_CLOSURES";
export const DELETE_CLOSURES_RESPONSE = "DELETE_CLOSURES_RESPONSE";
export const ADMIN_SETTINGS_CANCEL_CLICK = "ADMIN_SETTINGS_CANCEL_CLICK";
export const CLOSURE_ON_HIDE_LOADER = "CLOSURE_ON_HIDE_LOADER";
export const CLOSURE_ON_SHOW_LOADER = "CLOSURE_ON_SHOW_LOADER";
export const WORKING_HOURS_HIDE_LOADER = "WORKING_HOURS_HIDE_LOADER";
export const WORKING_HOURS_SHOW_LOADER = "WORKING_HOURS_SHOW_LOADER";
export const DAY_ERROR = "DAY_ERROR";
export const DAY_ERROR_RESPONSE = "DAY_ERROR_RESPONSE";
export const ADMIN_SETTINGS_ON_HIDE_LOADER = "ADMIN_SETTINGS_ON_HIDE_LOADER";
export const ADMIN_SETTINGS_ON_SHOW_LOADER = "ADMIN_SETTINGS_ON_SHOW_LOADER";


// Category admin action types

export const CATEGORY_ADMIN_SHOW_MESSAGE = "CATEGORY_ADMIN_show_message";
export const CATEGORY_ADMIN_HIDE_MESSAGE = "CATEGORY_ADMIN_hide_message";

export const CATEGORY_ADMIN_FETCH_ALL_CONTACT = "CATEGORY_ADMIN_fetch_all_contact";
export const CATEGORY_ADMIN_FETCH_ALL_CONTACT_SUCCESS = "CATEGORY_ADMIN_fetch_all_contact_success";

export const CATEGORY_ADMIN_ADD_FAVOURITE = "CATEGORY_ADMIN_add_favourite";
export const CATEGORY_ADMIN_ON_CONTACT_SELECT = "CATEGORY_ADMIN_on_contact_select";
export const CATEGORY_ADMIN_ON_ADD_CONTACT = "CATEGORY_ADMIN_on_add_contact";
export const CATEGORY_ADMIN_ON_ADD_CONTACT_STATE = "CATEGORY_ADMIN_ON_ADD_CONTACT_STATE";

export const CATEGORY_ADMIN_ON_CONTACT_CLOSE = "CATEGORY_ADMIN_on_contact_close";
export const CATEGORY_ADMIN_ON_FILTER_OPTION_SELECT = "CATEGORY_ADMIN_on_filter_option_select";

export const CATEGORY_ADMIN_ON_SAVE_CONTACT = "CATEGORY_ADMIN_on_save_contact";
export const CATEGORY_ADMIN_ON_SAVE_CONTACT_STATE = "CATEGORY_ADMIN_ON_SAVE_CONTACT_STATE";
export const CATEGORY_ADMIN_ON_DELETE_CONTACT = "CATEGORY_ADMIN_on_delete_contact";

export const CATEGORY_ADMIN_ON_DELETE_SELECTED_CONTACT =
  "CATEGORY_ADMIN_on_delete_selected_contact";
export const CATEGORY_ADMIN_FILTER_CONTACT = "CATEGORY_ADMIN_filter_contact";
export const CATEGORY_ADMIN_GET_ALL_CONTACT = "CATEGORY_ADMIN_get_all_contact";
export const CATEGORY_ADMIN_GET_UNSELECTED_ALL_CONTACT =
  "CATEGORY_ADMIN_get_unselected_all_contact";

export const CATEGORY_ADMIN_ON_ALL_CONTACT_SELECT = "CATEGORY_ADMIN_on_all_contact_select";
export const CATEGORY_ADMIN_UPDATE_SEARCH_USER = "CATEGORY_ADMIN_update_search_user";
export const CATEGORY_ADMIN_ON_TOGGLE_DRAWER = "CATEGORY_ADMIN_on_toggle_drawer";
export const CATEGORY_ADMIN_HANDLE_REQUEST_CLOSE = "CATEGORY_ADMIN_handle_request_close";

export const CATEGORY_ADMIN_HIDE_CONTACT_LOADER = "CATEGORY_ADMIN_hide_contact_loader";
export const CATEGORY_ADMIN_SHOW_CONTACT_LOADER = "CATEGORY_ADMIN_show_contact_loader";
export const SET_CATEGORY_IMAGE_FILE = "SET_CATEGORY_IMAGE_FILE";
export const GET_CATEGORY_IMAGE_FILE = "GET_CATEGORY_IMAGE_FILE";
export const CHANGE_CATEGORY_ADMIN_DISPLAY = "CHANGE_CATEGORY_ADMIN_DISPLAY";

export const SUBMIT_NEW_CATEGORY_ADMIN = "SUBMIT_NEW_CATEGORY_ADMIN";
export const SUBMIT_NEW_CATEGORY_ADMIN_RESPONSE = "SUBMIT_NEW_CATEGORY_ADMIN_RESPONSE";

export const FILL_ADMIN_CATEGORY_SELECTED_DETAILS = "FILL_ADMIN_CATEGORY_SELECTED_DETAILS";
export const SUBMIT_EDIT_CATEGORY_DETAILS = "SUBMIT_EDIT_CATEGORY_DETAILS";
export const SUBMIT_EDIT_CATEGORY_DETAILS_RESPONSE = "SUBMIT_EDIT_CATEGORY_DETAILS_RESPONSE";
export const CHANGE_ADD_CATEGORY_STATE = "CHANGE_ADD_CATEGORY_STATE";
export const CHANGE_EDIT_CATEGORY_STATE = "CHANGE_EDIT_CATEGORY_STATE";
export const CATEGORY_CLEAR_FORM_DATA = "CATEGORY_CLEAR_FORM_DATA";
export const SELECTED_CATEGORY_DELETE = "SELECTED_CATEGORY_DELETE";
export const SELECTED_CATEGORY_DELETE_RESPONSE = "SELECTED_CATEGORY_DELETE_RESPONSE";
export const BUSINESS_PROFILE_CANCEL = "BUSINESS_PROFILE_CANCEL";
export const BUSINESS_PROFILE_SAVE = "BUSINESS_PROFILE_SAVE";
export const BUSINESS_PROFILE_SAVE_RESPONSE = "BUSINESS_PROFILE_SAVE_RESPONSE";
export const BUSINESS_PROFILE_IMAGE_FILE = "BUSINESS_PROFILE_IMAGE_FILE";
export const BUSSINESS_GALLARY_IMAGE_FILE = "BUSSINESS_GALLARY_IMAGE_FILE";
export const BUSSINESS_GALLARY_IMAGE_FILE_REMOVE = "BUSSINESS_GALLARY_IMAGE_FILE_REMOVE";
export const BUSSINESS_GALLARY_IMAGE_FILE_SUCCESS = "BUSSINESS_GALLARY_IMAGE_FILE_SUCCESS";
export const BUSSINESS_GALLARY_IMAGE_FILE_ERROR = "BUSSINESS_GALLARY_IMAGE_FILE_ERROR";
export const BUSINESS_PROFILE_IMAGE_FILE_RESPONSE = "BUSINESS_PROFILE_IMAGE_FILE_RESPONSE";
export const REPORTS_GET_APPOINTMENTS = "REPORTS_GET_APPOINTMENTS";
export const REPORTS_SET_APPOINTMENTS = "REPORTS_SET_APPOINTMENTS";
export const REPORTS_SET_FILTER_START_DATE = "REPORTS_SET_FILTER_START_DATE";
export const REPORTS_SET_FILTER_END_DATE = "REPORTS_SET_FILTER_END_DATE";
export const REPORTS_SET_FILTER_STATUS = "REPORTS_SET_FILTER_STATUS";
export const REPORTS_SET_FILTER_EMPLOYEE = "REPORTS_SET_FILTER_EMPLOYEE";
export const REPORTS_GET_FILTER_DATA = "REPORTS_GET_FILTER_DATA";
export const REPORTS_TOGGLE_CHANGE = "REPORTS_TOGGLE_CHANGE";
export const REPORTS_HANDLE_REQUEST_CLOSE = "REPORTS_HANDLE_REQUEST_CLOSE";
export const REPORTS_ERROR_MESSAGE = "REPORTS_ERROR_MESSAGE";
export const REPORTS_SUCCESS_MESSAGE = "REPORTS_SUCCESS_MESSAGE";
export const TOGGLE_HEADER = "TOGGLE_HEADER";
export const ADD_SERVICES_BUSINESS_CATEGORY = "ADD_SERVICES_BUSINESS_CATEGORY"

// super-admin business list

export const SET_BUSINESS_ALL_DETAIL_REQUEST = "SET_BUSINESS_ALL_DETAIL_REQUEST";
export const SET_BUSINESS_ALL_DETAIL = "SET_BUSINESS_ALL_DETAIL";
export const FILTER_BUSINESS_LIST = "FILTER_BUSINESS_LIST";
export const SET_BUSINESS_DETAIL_FROM_LIST_REQUEST = "SET_BUSINESS_DETAIL_FROM_LIST_REQUEST";
export const SET_BUSINESS_DETAIL_FROM_LIST = "SET_BUSINESS_DETAIL_FROM_LIST";
export const BUSINESS_PROFILE_SAVE_SUPER = "BUSINESS_PROFILE_SAVE_SUPER";
export const BUSINESS_PROFILE_IMAGE_FILE_SUPER = "BUSINESS_PROFILE_IMAGE_FILE_SUPER";
export const HANDLE_REQUEST_CLOSE_BUSINESS_PROFILE = "HANDLE_REQUEST_CLOSE_BUSINESS_PROFILE";
export const TOGGLE_DISABLED_BUSINESS = "TOGGLE_DISABLED_BUSINESS";
export const TOGGLE_DISABLED_BUSINESS_PROFILE = "TOGGLE_DISABLED_BUSINESS_PROFILE";

// super-admin services list

export const GET_SERVICES_CATEGORY_SUPER_ADMIN = "GET_SERVICES_CATEGORY_SUPER_ADMIN";
export const SUBMIT_NEW_SERVICES_SUPER_ADMIN = "SUBMIT_NEW_SERVICES_SUPER_ADMIN";
export const DELETE_SERVICE_SUPER_ADMIN = "DELETE_SERVICE_SUPER_ADMIN";
export const APPOINTMENT_DELETE_SERVICES_FORCEFULLY_SUPER_ADMIN = "APPOINTMENT_DELETE_SERVICES_FORCEFULLY_SUPER_ADMIN";
export const GET_ALL_SERVICES_BY_BUSINESS_SUPER_ADMIN = "GET_ALL_SERVICES_BY_BUSINESS_SUPER_ADMIN";

// super-admin service category list

export const CATEGORY_SUPER_ADMIN_FETCH_ALL_CONTACT = "CATEGORY_SUPER_ADMIN_FETCH_ALL_CONTACT";
export const SUBMIT_NEW_CATEGORY_SUPER_ADMIN = "SUBMIT_NEW_CATEGORY_SUPER_ADMIN";
export const SELECTED_CATEGORY_DELETE_SUPER_ADMIN = "SELECTED_CATEGORY_DELETE_SUPER_ADMIN";
export const DELETE_CATEGORY_SUPER_ADMIN = "DELETE_CATEGORY_SUPER_ADMIN";

// super-admin user list

export const USER_ADMIN_ADD_FAVOURITE = "USER_ADMIN_ADD_FAVOURITE";
export const USER_ADMIN_FETCH_ALL_CONTACT = "USER_ADMIN_FETCH_ALL_CONTACT";
export const USER_ADMIN_FETCH_ALL_CONTACT_SUCCESS = "USER_ADMIN_FETCH_ALL_CONTACT_SUCCESS";
export const USER_ADMIN_FILTER_CONTACT = "USER_ADMIN_FILTER_CONTACT";
export const USER_ADMIN_GET_ALL_CONTACT = "USER_ADMIN_GET_ALL_CONTACT";
export const USER_ADMIN_GET_UNSELECTED_ALL_CONTACT = "USER_ADMIN_GET_UNSELECTED_ALL_CONTACT";
export const USER_ADMIN_HANDLE_REQUEST_CLOSE = "USER_ADMIN_HANDLE_REQUEST_CLOSE";
export const USER_ADMIN_HIDE_CONTACT_LOADER = "USER_ADMIN_HIDE_CONTACT_LOADER";
export const USER_ADMIN_ON_ADD_CONTACT = "USER_ADMIN_ON_ADD_CONTACT";
export const USER_ADMIN_ON_ALL_CONTACT_SELECT = "USER_ADMIN_ON_ALL_CONTACT_SELECT";
export const USER_ADMIN_ON_CONTACT_CLOSE = "USER_ADMIN_ON_CONTACT_CLOSE";
export const USER_ADMIN_ON_CONTACT_SELECT = "USER_ADMIN_ON_CONTACT_SELECT";
export const USER_ADMIN_ON_DELETE_CONTACT = "USER_ADMIN_ON_DELETE_CONTACT";
export const USER_ADMIN_ON_DELETE_SELECTED_CONTACT = "USER_ADMIN_ON_DELETE_SELECTED_CONTACT";
export const USER_ADMIN_ON_FILTER_OPTION_SELECT = "USER_ADMIN_ON_FILTER_OPTION_SELECT";
export const USER_ADMIN_ON_SAVE_CONTACT = "USER_ADMIN_ON_SAVE_CONTACT";
export const USER_ADMIN_ON_TOGGLE_DRAWER = "USER_ADMIN_ON_TOGGLE_DRAWER";
export const USER_ADMIN_SHOW_MESSAGE = "USER_ADMIN_SHOW_MESSAGE";
export const USER_ADMIN_UPDATE_SEARCH_USER = "USER_ADMIN_UPDATE_SEARCH_USER";
export const CHANGE_USER_ADMIN_DISPLAY = "CHANGE_USER_ADMIN_DISPLAY";
export const SET_USER_IMAGE_FILE = "SET_USER_IMAGE_FILE";
export const SUBMIT_NEW_USER_ADMIN = "SUBMIT_NEW_USER_ADMIN";
export const SUBMIT_NEW_USER_ADMIN_RESPONSE = "SUBMIT_NEW_USER_ADMIN_RESPONSE";
export const FILL_ADMIN_USER_SELECTED_DETAILS = "FILL_ADMIN_USER_SELECTED_DETAILS";
export const CHANGE_ADD_USER_STATE = "CHANGE_ADD_USER_STATE";
export const CHANGE_EDIT_USER_STATE = "CHANGE_EDIT_USER_STATE";
export const SUBMIT_EDIT_USER_DETAILS = "SUBMIT_EDIT_USER_DETAILS";
export const SUBMIT_EDIT_USER_DETAILS_RESPONSE = "SUBMIT_EDIT_USER_DETAILS_RESPONSE";
export const USER_CLEAR_FORM_DATA = "USER_CLEAR_FORM_DATA";
export const SELECTED_USER_DELETE = "SELECTED_USER_DELETE";
export const SELECTED_USER_DELETE_RESPONSE = "SELECTED_USER_DELETE_RESPONSE";
export const USER_FAIL_RESPONSE = "USER_FAIL_RESPONSE";
export const USER_ON_HIDE_LOADER2 = "USER_ON_HIDE_LOADER2";
export const USER_ON_SHOW_LOADER = "USER_ON_SHOW_LOADER";

// customer appointment

export const FETCH_ALL_CUSTOMER_APPOINTMENT = "FETCH_ALL_CUSTOMER_APPOINTMENT";
export const FETCH_ALL_CUSTOMER_APPOINTMENT_SUCCESS = "FETCH_ALL_CUSTOMER_APPOINTMENT_SUCCESS";
export const CANCEL_CUSTOMER_APPOINTMENT = "CANCEL_CUSTOMER_APPOINTMENT";
export const CANCEL_CUSTOMER_APPOINTMENT_SUCCESS = "CANCEL_CUSTOMER_APPOINTMENT_SUCCESS";

// customer profile

export const SUBMIT_EDIT_CUSTOMER_PROFILE = "SUBMIT_EDIT_CUSTOMER_PROFILE";
export const REQUEST_CUSTOMER_DATA = "REQUEST_CUSTOMER_DATA";
export const FILL_CUSTOMER_PROFILE_DETAILS = "FILL_CUSTOMER_PROFILE_DETAILS";
export const HANDLE_DATE_OF_BIRTH_CUSTOMER = "HANDLE_DATE_OF_BIRTH_CUSTOMER";
export const SET_CUSTOMER_PROFILE_IMAGE_FILE = "SET_CUSTOMER_IMAGE_FILE"


export const DELETE_GALLERY_IMAGE_REQUEST = "DELETE_GALLERY_IMAGE_REQUEST";

export const REMOVE_CUSTOMER_IMAGE_FILE = "REMOVE_CUSTOMER_IMAGE_FILE";


// WEBPACK FOOTER //
// ./constants/ActionTypes.js